import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=d9c742c6&scoped=true"
import script from "./SystemSetting.vue?vue&type=script&lang=js"
export * from "./SystemSetting.vue?vue&type=script&lang=js"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&id=d9c742c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c742c6",
  null
  
)

export default component.exports